import { useEffect, useState } from 'react';
import cn from 'classnames';
import styles from './header.module.scss';

const MIN_SCROLL_SHOW_HEADER = 200;

export const Header = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const { pageYOffset } = window;
      const isVisible = pageYOffset > MIN_SCROLL_SHOW_HEADER;
      setIsVisible(isVisible);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return <div className={cn(styles.header, { [styles.header__visible]: isVisible })}></div>;
};
